import React from "react";
import "./Heropage.css";
import profile from "../assets/final.gif";
import { Link } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";

const Heropage = () => {
  return (
    <div id="home" className="overflow-hidden">
      <div className="backdrop font-sans relative min-h-screen w-full bg-[#1E1E1E] overflow-hidden">
        <Link
          to="/timeline"
          className="text-[#FFCD29] text-2xl sm:text-2xl md:text-2xl lg:text-3xl absolute top-6 left-6 sm:top-10 sm:left-6 md:top-12  md:left-8 font-semibold hover:scale-105 transition-transform duration-200"
        >
          timeline
        </Link>
        <div className="flex flex-col sm:flex-row items-center justify-center min-h-screen w-full px-4 -mt-6">
          <div
            className="
              mb-10 md:mb-0
              md:mr-16 lg:mr-24 xl:mr-32
              h-60 w-60
              sm:h-48 sm:w-48
              md:h-80 md:w-80
              lg:h-96 lg:w-96
              flex-shrink-0
              transition-all
            "
          >
            <img
              className="rounded-lg border-2 border-[#FFCD29] w-full h-full object-cover shadow-lg"
              src={profile}
              alt="Profile"
            />
          </div>
          <div
            className="
              text-left
              w-60 sm:w-48
              md:w-100 lg:w-[30rem] xl:w-[34rem]
              md:h-80 lg:h-96 
              flex flex-col justify-end
              transition-all 
            "
          >
            <h1 className="text-white text-5xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl mb-6 md:mb-4">
              👋 hey ,
            </h1>
            <div className="space-y-2 md:space-y-2">
              <p className="text-white text-4xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl">
                i am a
              </p>
              <span className="text-[#FFCD29] text-4xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium block  md:h-20">
                <Typewriter
                  words={[
                    "software developer.",
                    "full-stack developer.",
                    "problem solver.",
                    "community enthusiast.",
                  ]}
                  loop={0}
                  cursor
                  cursorStyle="|"
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1500}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Heropage;
